import { lazy, Suspense } from "react";
import { Output } from "valibot";

import LoadingPlaceholder from "components/LoadingPlaceholder";
import { ConfigurationFieldTypeSchema } from "components/SonicBot/schemas";
import { getInputType } from "components/UserDataForm/InputComponent/functions";
import { LocaleSchema } from "shared/schemas";

const PhoneInput = lazy(() => import("react-phone-input-2"));

type Props = {
  id: string;
  type: Output<typeof ConfigurationFieldTypeSchema>;
  value: string;
  generationLanguage: Output<typeof LocaleSchema>;
  setInputValues?: (val: string) => void;
  isRequired?: boolean;
  isDeleted?: boolean;
  placeholder?: string;
  disabled?: boolean;
};

function InputComponent(props: Props) {
  const {
    type,
    value,
    generationLanguage,
    setInputValues,
    isRequired,
    isDeleted,
    placeholder,
    disabled,
  } = props;

  if (isDeleted) {
    return null;
  }

  const inputType = getInputType(type);
  const handleValueChange = (val: string) => {
    !!setInputValues && setInputValues(val);
  };

  if (type === "phone_number") {
    return (
      <Suspense
        fallback={
          <LoadingPlaceholder generationLanguage={generationLanguage} />
        }
      >
        <PhoneInput
          inputProps={{
            required: isRequired,
            className: "!pl-12",
          }}
          containerClass="label"
          specialLabel=""
          value={value}
          disabled={disabled ?? false}
          placeholder={placeholder}
          onChange={value => {
            handleValueChange(value);
          }}
        />
      </Suspense>
    );
  }
  if (type === "text_area") {
    return (
      <textarea
        autoFocus={disabled ? false : true}
        className="flex-1 border-transparent py-2 outline-none focus:border-transparent focus:ring-0"
        required={isRequired}
        disabled={disabled ?? false}
        value={value}
        placeholder={placeholder ?? ""}
        onChange={e => {
          handleValueChange(e.target.value);
        }}
      />
    );
  }
  return (
    <input
      required={isRequired}
      autoFocus={disabled ? false : true}
      value={value}
      className="flex-1 border-transparent py-2 outline-none focus:border-transparent focus:ring-0"
      type={inputType}
      disabled={disabled ?? false}
      placeholder={placeholder ?? ""}
      onChange={e => {
        handleValueChange(e.target.value);
      }}
    />
  );
}

export default InputComponent;
